import React from 'react';
import { Button, Icon } from 'antd';

import AddBrandModal from './add-brand-modal';

class AddBrandButton extends React.Component{

	render(){

		const { modalIsOpen } = this.state;

		return (
			<div>

				<AddBrandModal 
					modalIsOpen={modalIsOpen}
					onCloseModal={this.closeModal}
					/>

				<Button onClick={this.openModal}>
					<Icon type="plus-square" />
					Add New Brands
				</Button>
			</div>
		)
	}

	state = { 
		modalIsOpen: false
	}

	openModal = () => {
		this.setState({
			modalIsOpen: true
		})
	}

	closeModal = () => {
		this.setState({
			modalIsOpen: false
		})
	}

}

export default AddBrandButton;


// WEBPACK FOOTER //
// ./src/components/brands/add-brand-button.js